import { parseISO } from 'date-fns';
import { useFormatterInstanceContext } from './context';

type Formatters = {
  formatDate: (date: string | Date, options?: { type: 'short' | 'medium' | 'long' }) => string;
  formatCurrency: (value: number) => string;
  formatInteger: (value: number) => string;
  formatWeight: (value: number) => string;
};

export const useFormatter = (): Formatters => {
  const instance = useFormatterInstanceContext();
  return {
    formatDate: (date, options) => {
      const { type = 'short' } = options ?? {};
      const actualDate = typeof date === 'string' ? parseISO(date) : date;
      const formatter =
        type === 'long'
          ? instance.dateLongFormatter
          : type === 'medium'
            ? instance.dateMediumFormatter
            : instance.dateShortFormatter;

      return formatter.format(actualDate);
    },
    formatCurrency: (value) => {
      return instance.numberCurrencyFormatter.format(value);
    },
    formatInteger: (value) => {
      return instance.integerFormatter.format(value);
    },
    formatWeight: (value) => {
      return instance.numberFormatter.format(value);
    },
  };
};
